/**
 * ProvinceSoftwareGrid — SEO-focused internal link hub. Every province
 * software page is one click from the homepage so Google can crawl them
 * and PageRank flows in. Also the canonical entry point for users
 * searching "property management software in [province]".
 *
 * Extracted from Landing.jsx in the components-split refactor.
 */
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { LANDING_PROVINCES, SOFTWARE_SLUG } from "@/data/landing";

export default function ProvinceSoftwareGrid() {
  return (
    <section id="software-by-province" className="py-16 md:py-20 bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <div className="text-xs tracking-[0.22em] uppercase font-bold text-emerald-700">Property management software by province</div>
          <h2 className="font-display mt-3 text-2xl sm:text-3xl md:text-4xl font-bold tracking-tighter text-slate-900 leading-[1.05]">
            Pick your province. Software calibrated to each one.
          </h2>
          <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">
            Province-specific lease forms, notice templates, rent-cap math and tax exports for every Canadian jurisdiction — from the LTB in Ontario to the RTB in BC to the TAL in Quebec.
          </p>
        </div>
        <div className="mt-8 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 gap-2" data-testid="software-by-province-grid">
          {LANDING_PROVINCES.map(([code, name]) => (
            <Link
              key={code}
              to={`/landlord-software/${SOFTWARE_SLUG[code]}`}
              data-testid={`software-province-${code}`}
              className="group bg-slate-50 border border-slate-200 hover:border-emerald-300 hover:bg-white hover:shadow-md transition-all rounded-lg px-2.5 py-2.5 flex items-center justify-between gap-1.5"
            >
              <div className="min-w-0">
                <div className="text-[9px] uppercase tracking-[0.14em] font-bold text-emerald-700">{code}</div>
                <div className="text-xs font-bold text-slate-900 mt-0.5 leading-tight truncate">{name}</div>
              </div>
              <ArrowRight className="w-3 h-3 flex-none text-slate-400 group-hover:text-emerald-700 group-hover:translate-x-0.5 transition-all"/>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
